// extracted by mini-css-extract-plugin
export default {"tdBorder":"LobbyLeaderboard_tdBorder__+f-r-","avatarCSS":"LobbyLeaderboard_avatarCSS__AnXnl"};